import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { IRootState } from "../../store";
import DispatchProps from "../../utils/DispatchProps";
import {
    CommandBarButton, MessageBarType,
} from "office-ui-fabric-react";
import ApiService from "../ApiService";
import UserSelector from "../UserSelector";
import Actions from "../../redux/Actions";
import H from "history";
import PageTitle from "../PageTitle";
import { UserOption } from '../UserSelectorBase';
import TenantManagerPage from './TenantManagerPage';
import SchoolMenu from '../SchoolMenu';

interface TenantManagerAddPageProps {
    tenantId: string;
    apiService: ApiService;
    history: H.History;
}

interface TenantManagerAddPageState {
    selectedUsers: UserOption[];
}

class TenantManagerAddPage extends Component<TenantManagerAddPageProps & DispatchProps, TenantManagerAddPageState> {
    static displayName = TenantManagerAddPage.name;
    
    constructor(props: TenantManagerAddPageProps & DispatchProps) {
        super(props);

        this.state = {
            selectedUsers: [],
        }
    }
    
    protected submitForm = async () => {
        try {
            if (this.state.selectedUsers.length < 1) {
                return;
            }

            await Promise.all(this.state.selectedUsers.map((userOption) => {
                return this.props.apiService.createTenantManagerRecord({
                    tenantId: this.props.tenantId,
                    userOid: userOption.id
                });
            }));

            this.props.dispatch(Actions.showMessageBar("Saved successfully", MessageBarType.success));
            this.props.history.push(`/manage-tenant/${this.props.tenantId}/tenant-manager`);
        }
        catch (e) {
            this.props.dispatch(Actions.showMessageBar("Failed to save access", MessageBarType.error));
        }
    };
    
    render() {
        return (
            <Fragment>
                <PageTitle title={`Tenant Manager (add)`} />

                <SchoolMenu prefix="Tenant Manager" prefixLink={`/manage-tenant/${this.props.tenantId}/tenant-manager`} suffix="Add"/>

                {TenantManagerPage.buildHelpBox()}

                <div className="card card">
                    <div className="card__header">
                        <span className={"card__title"}>Add user(s) to tenant manager</span>

                        <CommandBarButton
                            iconProps={{ iconName: "save" }}
                            text="Save"
                            onClick={this.submitForm}
                        />
                    </div>

                    <div className="card__content flex-column">
                        <UserSelector
                            tenantId={this.props.tenantId}
                            className="card__input"
                            disabled={false}
                            multiSelect={false}
                            label={"Users"}
                            selectedUsers={this.state.selectedUsers}
                            onSelectionChanged={(selectedUsers: UserOption[]) => {
                                this.setState({
                                    selectedUsers
                                });
                            }} />
                    </div>
                </div>

            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { match: any, history: H.History }): TenantManagerAddPageProps => {
        return {
            apiService: state.auth.apiService,
            tenantId: ownProps.match.params.tenantId,
            history: ownProps.history
        };
    }
)(TenantManagerAddPage)